type AuthDebugState = {
  checkAuthCalls: number;
  meCalls: number;
  redirects: Record<string, number>;
  lastEvents: string[];
};

const MAX_EVENTS = 40;

function getStore(): AuthDebugState {
  if (typeof window === 'undefined') {
    return { checkAuthCalls: 0, meCalls: 0, redirects: {}, lastEvents: [] };
  }
  const w = window as Window & { __AUTH_DEBUG__?: AuthDebugState };
  if (!w.__AUTH_DEBUG__) {
    w.__AUTH_DEBUG__ = { checkAuthCalls: 0, meCalls: 0, redirects: {}, lastEvents: [] };
  }
  return w.__AUTH_DEBUG__;
}

function pushEvent(message: string): void {
  if (process.env.NODE_ENV === 'production') return;
  const store = getStore();
  store.lastEvents.push(`${new Date().toISOString()} ${message}`);
  if (store.lastEvents.length > MAX_EVENTS) {
    store.lastEvents.splice(0, store.lastEvents.length - MAX_EVENTS);
  }
}

export function authDebugEnabled(): boolean {
  return (
    process.env.NEXT_PUBLIC_AUTH_DEBUG === 'true' ||
    process.env.NEXT_PUBLIC_LOGIN_REDIRECT_TRACE === 'true'
  );
}

export function logAuthEvent(event: string, payload?: Record<string, unknown>): void {
  if (!authDebugEnabled()) return;
  pushEvent(event);
  if (payload) {
    console.info(event, payload);
  } else {
    console.info(event);
  }
}

export function incrementCheckAuthCalls(reason?: string): void {
  const store = getStore();
  store.checkAuthCalls += 1;
  logAuthEvent('checkAuth_start', { reason, count: store.checkAuthCalls });
}

export function logCheckAuthSuccess(reason?: string): void {
  logAuthEvent('checkAuth_success', { reason });
}

export function logCheckAuthFailed(reason: string, detail?: Record<string, unknown>): void {
  logAuthEvent('checkAuth_failed', { reason, ...detail });
}

export function incrementMeCalls(): void {
  const store = getStore();
  store.meCalls += 1;
}

export function trackRedirect(destination: string): void {
  const store = getStore();
  const key = destination.split('?')[0];
  store.redirects[key] = (store.redirects[key] ?? 0) + 1;
  if (store.redirects[key] > 3) {
    console.warn('possible_auth_loop', { destination: key, count: store.redirects[key] });
  }
}

export function getAuthDebugState(): AuthDebugState {
  return getStore();
}

export function resetAuthDebugState(): void {
  if (typeof window === 'undefined') return;
  const w = window as Window & { __AUTH_DEBUG__?: AuthDebugState };
  w.__AUTH_DEBUG__ = { checkAuthCalls: 0, meCalls: 0, redirects: {}, lastEvents: [] };
}
